export const reportSalesByZoneWholesalerTypes = {
  SET_SALES_BY_ZONE_WHOLESALER_FILTERS: 'SET_SALES_BY_ZONE_WHOLESALER_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
